import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { AdminCard, Badge } from "./AdminLayout";
import { toast } from "sonner";

export default function AdminInventory() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/inventory").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async (row, val) => { try { await api.put("/admin/inventory", { product_id: row.product_id, sku: row.sku, stock: Number(val) }); toast("Stock updated"); load(); } catch (e) { toast.error(apiErr(e)); } };
  return (
    <div>
      <h1 className="font-serif text-3xl mb-6">Inventory</h1>
      <AdminCard className="overflow-x-auto p-0">
        <table className="w-full text-sm min-w-[720px]">
          <thead className="bg-sharoa-ivory text-left text-xs uppercase text-sharoa-muted"><tr>{["Product", "SKU", "Size", "Color", "Available", "Reserved", "Sold", "Alert"].map((h) => <th key={h} className="py-3 px-4">{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.sku} className="border-t border-sharoa-line">
                <td className="py-2.5 px-4">{r.product}</td>
                <td className="py-2.5 px-4 font-mono text-xs">{r.sku}</td>
                <td className="py-2.5 px-4">{r.size}</td>
                <td className="py-2.5 px-4">{r.color}</td>
                <td className="py-2.5 px-4"><input data-testid={`inv-stock-${r.sku}`} type="number" min="0" defaultValue={r.available} onBlur={(e) => Number(e.target.value) !== Number(r.available) && save(r, e.target.value)} onKeyDown={(e) => e.key === "Enter" && e.target.blur()} className="w-16 border border-sharoa-line px-2 py-1" /></td>
                <td className="py-2.5 px-4">{r.reserved}</td>
                <td className="py-2.5 px-4">{r.sold}</td>
                <td className="py-2.5 px-4">{r.out ? <Badge tone="red">Out of Stock</Badge> : r.low ? <Badge tone="amber">Low Stock</Badge> : <Badge tone="green">OK</Badge>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </AdminCard>
    </div>
  );
}
